import type { Movie } from "@/mocks/movies";

export interface MovieFilters {
  type?: string;
  regions?: string[];
  years?: string[];
  genres?: string[];
  keyword?: string;
  sort?: string;
}

export function filterMovies(list: Movie[], filters: MovieFilters): Movie[] {
  const { type, regions, years, genres, keyword, sort } = filters;

  let result = list.filter((movie) => {
    if (type && type !== "all" && movie.type !== type) return false;

    if (regions && regions.length > 0 && !regions.includes(movie.region)) {
      return false;
    }

    if (years && years.length > 0 && !years.includes(String(movie.year))) {
      return false;
    }

    if (
      genres &&
      genres.length > 0 &&
      !movie.genres.some((g) => genres.includes(g))
    ) {
      return false;
    }

    if (keyword && keyword.trim()) {
      const kw = keyword.trim().toLowerCase();
      const haystack = [
        movie.title,
        movie.director,
        movie.region,
        ...movie.actors,
        ...movie.genres,
      ]
        .join(" ")
        .toLowerCase();
      if (!haystack.includes(kw)) return false;
    }

    return true;
  });

  result = [...result];

  if (sort === "new") {
    result.sort((a, b) => b.year - a.year);
  } else if (sort === "rating") {
    result.sort((a, b) => b.rating - a.rating);
  } else {
    result.sort((a, b) => b.plays - a.plays);
  }

  return result;
}

export interface PaginationResult<T> {
  items: T[];
  totalPages: number;
  total: number;
}

export function paginate<T>(list: T[], page: number, pageSize: number): PaginationResult<T> {
  const total = list.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const safePage = Math.min(Math.max(1, page), totalPages);
  const start = (safePage - 1) * pageSize;
  return {
    items: list.slice(start, start + pageSize),
    totalPages,
    total,
  };
}